export default __webpack_public_path__ + "static/media/Icon feather-minus-circle.a95516af.svg";